import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const Chip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid ${COLORS.borderColor};
  background-color: ${COLORS.primaryExtraLight};
  white-space: nowrap;
`

export const ThunderImage = styled.img`
  width: 10px;
  height: 10px;
  flex-shrink: 0;
`

export const Wrapper = styled.div`
  display: flex;
`
